import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import BenefitDetail from './components/BenefitDetail';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ErrorBoundary from './components/ErrorBoundary';
import useBenefitToken from './hooks/useBenefitToken';
import useFetchBenefits from './hooks/useFetchBenefits';
import './styles.css';

const App = () => {
  useBenefitToken();
  const { benefits, loading, error, retry } = useFetchBenefits(process.env.REACT_APP_API_URL);

  return (
    <ErrorBoundary>
      <Router>
        <div className="app">
          <ScrollToTop />
          <Navbar />
          <main className="content" role="main">
            <Routes>
              <Route
                path="/"
                element={<Home benefits={benefits} loading={loading} error={error} retry={retry} />}
              />
              <Route
                path="/beneficios/:slug"
                element={<BenefitDetail benefits={benefits} loading={loading} retry={retry} />}
              />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ErrorBoundary>
  );
};

export default App;
